<template>
    <section class="gh-summit-section l-speakers" id="speakers">
        <div class="container">
            <h3 class="section-heading gh-heading gh-lightBlue">Meet our Speakers</h3>
            <p class="gh-sub-heading">
                Bringing you experts in suicidology and suicide prevention.
            </p>
            <p class="gh-body">
                The Summit delivers you a unique line-up of renowned practitioners, researchers, authors and educators. Whether you decide to attend the live sessions, or watch the event’s on-demand recorded videos – you can rest assured you’ll be learning from the best.
            </p>
            <div class="gh-speakers">
                <div
                    v-for="speaker in speakers"
                    :key="speaker.id"
                    @click="viewSpeaker(speaker)"
                    class="gh-speaker"
                    style="margin-bottom: 10px"
                >
                    <el-card :body-style="{ padding: '0px' }" style="position: relative;">
                        <div v-if="device !=='mobile' && device !=='tablet'">
                            <div @click="dialogVisible = true" @mouseleave="closeAbout()" v-if="speaker.id === about" class="gh-background">
                                <div class="gh-about-button">BIO</div>
                            </div>
                            <img @mouseover="openAbout(speaker)"  :src="speakerAvatar(speaker)" :alt="speaker.name" class="image">
                            <div class="gh-name-panel bg-light-grey">
                                <span class="text-dark-blue gh-speaker-name">{{ speaker.name !== 'Jane Boland' ? 'Dr. ' : ''}}{{ speaker.name }}</span><br />
                                <span class="gh-work text-dark-grey" v-html="speaker.work"></span>
                            </div>
                        </div>
                        <div v-else>
                            <img :src="speakerAvatar(speaker)" :alt="speaker.name" class="image">
                            <div class="gh-name-panel bg-light-grey">
                                <el-row>
                                    <el-col :span="19">
                                        <span class="text-dark-blue gh-speaker-name">{{ speaker.name }}</span><br />
                                        <span class="gh-work text-dark-grey" v-html="speaker.work"></span>
                                    </el-col>
                                    <el-col :span="5">
                                        <button @click="viewSpeaker(speaker); dialogVisible = true" class="gh-button mt-1">BIO</button>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>

            <el-dialog
                :visible.sync="dialogVisible"
                custom-class="gh-speaker-bio"
                :width="dialog"
            >
                <div>
                    <el-row :gutter="30">
                        <el-col v-if="device !=='mobile'" :xs="24" :sm="10">
                            <img :src="speakerAvatar(viewingSpeaker)" :alt="viewingSpeaker.name">
                        </el-col>
                        <el-col :xs="24" :sm="14">
                            <h4 class="gh-speaker-name">{{ viewingSpeaker.name }}</h4>
                            <h4 class="gh-speaker-name"><span class="gh-speaker-qualifications" v-html="viewingSpeaker.qualifications"></span></h4><br>
                            <div class="gh-speaker-qualifications">
                                <p v-for="position in viewingSpeaker.positions" :key="position">{{ position }}</p>
                            </div><br>
                            <div class="gh-speaker-bio-body" v-html="viewingSpeaker.bio"></div>
                        </el-col>
                    </el-row>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">Close</el-button>
                </span>
            </el-dialog>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                viewingSpeaker: {},
                about: 0,
                dialog: '50%'
            }
        },
        created() {
            this.onResize()
            window.addEventListener('resize', this.onResize)
        },

        computed: {
            speakers() {
                return this.$store.state.event.eventSpeakers
            },
            device() {
                return this.$store.getters['ui/getDevice'];
            },
        },

        methods: {
            onResize() {
                if (window.innerWidth >= 1366) {
                    this.dialog = '50%'
                } else {
                    this.dialog = '90%'
                }
            },
            viewSpeaker(speaker) {
                this.viewingSpeaker = {...speaker}
                this.dialogVisible = true
            },

            speakerAvatar(speaker) {
                return `/images/suicidePreventionSummit/speakers/speaker-images${speaker.id}.jpg`
            },

            openAbout(speaker) {
                this.viewingSpeaker = speaker
                this.about = speaker.id
            },
            closeAbout() {
                this.about = 0
            },
        }
    }
</script>

<style scoped lang="scss">
    .l-speakers {
        background: white;
    }

    .gh-summit-section {
        padding: 2rem 0;
    }

    .gh-speakers {
        display: flex;
        flex-flow: row wrap;
        margin: -.5rem;
    }

    .gh-speaker {
        display: grid;
        width: 23.5%;
        margin: .5rem;
    }

    .image {
        width: 100%;
        display: block;
    }

    .el-card {
        border: none;
        border-radius: 3px;
        background: #e1e3e5;
    }

    .gh-speaker-qualifications {
        word-break: keep-all;
    }

    .gh-heading {
        margin-bottom: 20px;
    }
    .gh-sub-heading {
        font-size: 1.6rem;
      font-weight: 500;
      font-family: 'proxima-nova', sans-serif;
      color: #474F59;
    }
    .gh-body {
        font-size: 1.1rem;
        margin: 10px 0 30px;
      font-weight: 500;
      font-family: 'proxima-nova', sans-serif;
      color: #474F59;

    }
    .gh-name-panel {
        padding: 14px;
    }
    .gh-about-button {
        position:absolute;
        color: white;
        border: 2px solid white;
        padding: 10px 30px;
        margin: 50%;
        transform: translate(-50%, -50%);
    }
    .gh-background {
        background-color: rgba(0,0,0,0.4);
        width: 100%;
        position: absolute;
        height: 100%;
        cursor: pointer;
    }
    .gh-speaker-avatar {
        width: 30%;
    }

    .gh-speaker-name {
        font-size: 1.2rem;
        font-weight: 700;
        font-family: 'proxima-nova', sans-serif;
    }

    .gh-speaker-qualifications {
        font-size: 1.2rem;
        font-weight: 700;
        color: #474f59;
    }

    .gh-button {
        background-color: rgb(71, 79, 89);
        color: white;
        &:hover {
            background-color: #727880;
        }
    }

    .gh-speaker-bio {
        h4 + h4 {
            margin-top: 1rem;
        }
    }

    .gh-speaker-bio-body {
        word-break: normal;
        font-family: proxima-nova,sans-serif;
    }
    .gh-work {
        font-size: 1rem;
        line-height: 1.2;
        display: inline-block;
      font-family: 'proxima-nova', sans-serif;
    }

    @media screen and (max-width: 1280px) {
        .gh-speaker {
            width: 31%;
        }
    }

    @media screen and (max-width: 1120px) {
        .gh-speaker {
            width: 31.5%;
        }
    }

    @media screen and (max-width: 991px) {
        .gh-speaker {
            width: 31%;
        }
    }

    @media screen and (max-width: 840px) {
        .gh-speaker {
            width: 47.5%;
        }
    }

    @media screen and (max-width: 600px) {
        .gh-speaker {
            width: 46%;
        }
    }

    @media screen and (max-width: 480px) {
        .gh-speaker {
            width: 100%;
        }
    }
</style>
<style lang="scss">
    .l-speakers {
        .gh-speaker-bio-body {
            p + p {
                margin-top: 1rem;
            }
        }
    }
</style>